export var OrderOptions;
(function (OrderOptions) {
    OrderOptions["POPULARITY"] = "POPULARITY";
    OrderOptions["ALPHABETICALLY"] = "ALPHABETICALLY";
})(OrderOptions || (OrderOptions = {}));
//# sourceMappingURL=order-selector.types.js.map